// removed by extract-text-webpack-plugin
module.exports = {"project":"Project-cssmodule-project-2LJBk","title":"Project-cssmodule-title-m079l","badge":"Project-cssmodule-badge-21ez7","badgeIcon":"Project-cssmodule-badgeIcon-230cK","lecture":"Project-cssmodule-lecture--_Wrt","titleText":"Project-cssmodule-titleText-LgXe8","contentView":"Project-cssmodule-contentView-3AG6o","content":"Project-cssmodule-content-o1DfS","media":"Project-cssmodule-media-29-3t","buttonView":"Project-cssmodule-buttonView-1R4m7","button":"Project-cssmodule-button-oJ7QD","negativeButton":"Project-cssmodule-negativeButton-1xVfP"};


//////////////////
// WEBPACK FOOTER
// ./themes/BlueTheme/Project.cssmodule.less
// module id = 679
// module chunks = 0